import { put } from "redux-saga/effects";
import { ApiCaller, Utils } from "../../config";
import { DisputeActions } from "../actions";

export default class DisputeMiddleware {
    static *getDisputes(params) {
        const { payload } = params;
        try {
            let res = yield ApiCaller.Get(`/admin/dispute-listing?limit=${payload?.limit}&offset=${payload?.offset}${payload?.startDate && `&startDate=${payload?.startDate}`}${payload?.endDate && `&endDate=${payload?.endDate}`}&status=${payload?.status}&like=${payload?.search}`);
            if (res?.status == 200) {
                yield put(DisputeActions.getAllDisputesSuccess(res?.data?.data));
            } else {
                yield put(DisputeActions.getAllDisputesFailure());
                Utils.showSnackBar({
                    message: res?.data?.error?.message,
                    severity: "error",
                });
            }
        } catch (error) {
            yield put(DisputeActions.getAllDisputesFailure());
            Utils.showSnackBar({
                message: error?.data?.error?.message,
                severity: "error",
            });
        }
    }


    static *exportDisputes(params) {
        const { payload, cb } = params;
        try {
            let res = yield ApiCaller.Get(`/admin/export/dispute?limit=${payload?.limit}&offset=${payload?.offset}${payload?.startDate && `&startDate=${payload?.startDate}`}${payload?.endDate && `&endDate=${payload?.endDate}`}&status=${payload?.status}&like=${payload?.search}`);
            if (res?.status == 200) {
                Utils.showSnackBar({ message: res?.data?.data?.message });
                cb && cb(res?.data?.data?.url)
            } else {
                Utils.showSnackBar({
                    message: res?.data?.error?.message,
                    severity: "error",
                });
            }
        } catch (error) {
            Utils.showSnackBar({
                message: error?.data?.error?.message,
                severity: "error",
            });
        }
    }

    static *disputeDetail(params) {
        const { payload, cb } = params;
        // console.log(payload)
        try {
            let res = yield ApiCaller.Get(`/admin/dispute/${payload}`);
            if (res?.status == 200) {
                Utils.showSnackBar({ message: res?.data?.data?.message });
                yield put(DisputeActions.disputeDetailSuccess(res?.data?.data?.dispute));
                cb && cb()
            } else {
                yield put(DisputeActions.disputeDetailFailure());
                Utils.showSnackBar({
                    message: res?.data?.error?.message,
                    severity: "error",
                });
            }
        } catch (error) {
            yield put(DisputeActions.disputeDetailFailure());
            Utils.showSnackBar({
                message: error?.data?.error?.message,
                severity: "error",
            });
        }
    }


}


// payload: {
//     limit: 10,
//     offset: 0,
//     page: 1,
//     search: '',
//     status: 'all',
//     startDate: '',
//     endDate: ''
//   },